import { useCallback } from 'react';
import { useTranslation } from 'react-i18next';

export const useTranslateFolderName = () => {
  const { t } = useTranslation();

  return useCallback(
    (foldername: string) => {
      const fileTranslations = {
        instructions: t('documents.foldernames.instructions', 'Consignes'),
      };

      if (Object.prototype.hasOwnProperty.call(fileTranslations, foldername)) {
        return fileTranslations[foldername as keyof typeof fileTranslations];
      }

      return foldername;
    },
    [t]
  );
};
